import { HeroAvatar, useHeroLookup } from "@/features/matches";
import { cn } from "@/shared/lib";

type HeroFacesProps = {
  heroIds: number[];
  size?: number;
  className?: string;
};

// Портреты героев в строке описания. Имена — для экранного диктора и подсказкой по
// наведению: новичок героев по портретам не помнит.
export const HeroFaces = ({ heroIds, size = 20, className }: HeroFacesProps) => {
  const hero = useHeroLookup();
  if (heroIds.length === 0) {
    return null;
  }
  const heroes = heroIds.map(hero);
  return (
    <span className={cn("inline-flex items-center gap-1", className)}>
      {heroes.map((view, index) => (
        <span key={`${view.id}-${index}`} title={view.name} className="inline-flex">
          <HeroAvatar
            name={view.name}
            iconUrl={view.iconUrl}
            size={size}
            className="rounded-[5px]"
          />
        </span>
      ))}
      <span className="sr-only">{heroes.map((view) => view.name).join(", ")}</span>
    </span>
  );
};
